import { useCallback, useRef } from 'react'
import { ScrollView } from 'react-native'

import FosterAdoptionCard from '@/components/fosters/cards/FosterAdoptionsCard'
import FosterDocumentsCard from '@/components/fosters/cards/FosterDocumentsCard'
import FosterHealthCard from '@/components/fosters/cards/FosterHealthCard'
import FosterNotesCard from '@/components/fosters/cards/FosterNotesCard'
import FosterProfileCard from '@/components/fosters/cards/FosterProfileCard'
import { useFosterFormContext } from '@/components/fosters/FosterFormContext'
import Page from '@/components/shared/Page'
import useFosterOwner from '@/hooks/useFosterOwner'
import FosterService from '@/services/fosterService'
import { useAppStore } from '@/store/useAppStore'

interface Props {
  fosterId: string
}

const FosterPage = ({ fosterId }: Props) => {
  const { refreshFoster } = FosterService.useFoster(fosterId)
  const isFosterOwner = useFosterOwner(fosterId)

  const currentOrganization = useAppStore.use.currentOrganization().organization

  const { control, formState, setValue } = useFosterFormContext()

  const onRefresh = useCallback(async () => {
    await refreshFoster()
  }, [refreshFoster])

  const isDisabled = !currentOrganization?.subscriptionActive || !isFosterOwner

  const scrollRef = useRef<ScrollView>(null)

  return (
    <Page
      key={`foster-page-${fosterId}`}
      onRefresh={onRefresh}
      scrollRef={scrollRef}
      viewId="foster-detail-scroll-view"
    >
      <FosterProfileCard
        control={control}
        disabled={isDisabled}
        formState={formState}
        fosterId={fosterId}
      />
      <FosterHealthCard
        control={control}
        disabled={isDisabled}
        formState={formState}
        fosterId={fosterId}
        scrollRef={scrollRef}
        setValue={setValue}
      />
      <FosterNotesCard
        control={control}
        disabled={isDisabled}
        formState={formState}
        fosterId={fosterId}
      />
      <FosterAdoptionCard
        control={control}
        disabled={isDisabled}
        fosterId={fosterId}
      />
      <FosterDocumentsCard disabled={isDisabled} fosterId={fosterId} />
    </Page>
  )
}

export default FosterPage
